import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { actionGenerator } from '../../redux/actionGenerator';
import { EFormLayoutModalActionType } from './types';
import { EEventType } from '../../types/eventEmitter';
import { selectSendFeedbackSucceed } from '../../selectors/sendFeedback';
import { setStatusInitial as setSendFeedbackStatusInitial } from '../sendFeedback';
import { generateFormKey } from '../formKey';
import { updateFormInitialState } from '../formInitialState';
var closeModal = actionGenerator(EFormLayoutModalActionType.Closed);
export function closeFormLayoutModal(values) {
  var _ref;
  return function (_x, _x2, _x3) {
    return (_ref = _ref || _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      var state, emitter, isSendFeedbackSucceed;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            state = getState();
            emitter = context.emitter;
            isSendFeedbackSucceed = selectSendFeedbackSucceed(state);
            dispatch(closeModal());
            emitter.emit(EEventType.FormLayoutModalClosed);
            if (isSendFeedbackSucceed) {
              dispatch(setSendFeedbackStatusInitial());
            }

            // Если мы не дошли до отправки формы, то обновим её formInitialState перед закрытием
            if (!(values && !isSendFeedbackSucceed)) {
              _context.next = 9;
              break;
            }
            _context.next = 9;
            return dispatch(updateFormInitialState(values));
          case 9:
            // Каждый раз при закрытии модалки будем провоцировать сброс формы к первому шагу
            dispatch(generateFormKey());
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))).apply(this, arguments);
  };
}